// extracted by mini-css-extract-plugin
module.exports = {"burgerButton":"BurgerButton_burgerButton__s2P9j","burgerIcon":"BurgerButton_burgerIcon__16DyH"};